import React, {useEffect} from 'react';
import {makeStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Panel from './Panel';
import Details from './Details';
import {useDispatch, useSelector} from 'react-redux';
import {fetchSimulation} from '../actions/async-actions';

const useStyles = makeStyles({
    relative: {
        position: 'relative'
    },
    container: {
        marginTop: '-50px',
        height: '100%'
    }
});

const FeesSimulator = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const paymentAmount = useSelector(reducer => reducer.appState.get('paymentAmount'));
    const cardType = useSelector(reducer => reducer.appState.get('cardType'));
    const paymentCurrency = useSelector(reducer => reducer.appState.get('paymentCurrency'));
    const convertedAmount = useSelector(reducer => reducer.appState.getIn(['simulation', 'convertedAmount']));

    useEffect(() => {
        if (!convertedAmount) {
            dispatch(fetchSimulation(paymentAmount, cardType, paymentCurrency));
        }
    }, [dispatch, convertedAmount, paymentAmount, cardType, paymentCurrency]);

    return (
        <Grid container className={classes.container} spacing={0}>
            <Grid item className={classes.relative} xs={12} md={6}>
                <Panel/>
            </Grid>
            <Grid item className={classes.relative} xs={12} md={6}>
                <Details/>
            </Grid>
        </Grid>
    );
};

export default React.memo(FeesSimulator);
